module.exports = __webpack_public_path__ + "static/finovate-topleass-atm-2014-c2f0d4b9a990097f2bd7d015d148233d.png";